import styled from 'styled-components';
import { Text } from '@shared/ui-components';


const RowContainer = styled.div`
  display: grid;
  grid-template-columns: 226px 70px 102px 127px;
  border: 1px solid ${p => p.theme.color.background};
  height: 50px;
  justify-items: center;
  align-items: center;

  &, * {
    box-sizing: border-box;
  }
`;

const Cell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  border-right: 1px solid ${p => p.theme.color.background};

  ${Text} {
    font-size: 14px;
  }
`;

const ContentWrapper = styled.div<{ isItem?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${p => p.isItem ? 'start' : 'end'};
  width: 100%;
  height: 100%;
  margin-left: ${p => p.isItem ? '15px' : undefined};
  margin-right: ${p => p.isItem ? undefined : '15px'};
`;

const FooterBlock = styled.div`
  width: 100%;

  > div:first-child {
    padding-top: 15px;
  }
`;

export const Styled = {
  RowContainer,
  Cell,
  ContentWrapper,
  FooterBlock,
};
